import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allOrganisms: [],
};

export const organismsSlice = createSlice({
  name: "organisms",
  initialState,
  reducers: {
    setAllOrganisms: (state, action) => {
      state.allOrganisms = action.payload;
    },
  },
});

export const { setAllOrganisms } = organismsSlice.actions;

export default organismsSlice.reducer;
